import { EVENT_TYPES } from "./constants";
import { eventHandlers } from "./event-handlers";
import type { AppStore } from "../../store";

export const handleMessage = (storeAPI: AppStore) => (e: MessageEvent) => {
  const msg = JSON.parse(e.data);

  switch (msg.event) {
    case EVENT_TYPES.MESSAGE_INCOME:
      eventHandlers.newMessage(storeAPI, msg.content);
      eventHandlers.showNotification(storeAPI, msg.content);
      eventHandlers.setOperatorName(storeAPI, msg.content);
      break;

    case EVENT_TYPES.UPDATE_FILE_MESSAGE:
      eventHandlers.updateFileMessage(storeAPI, msg.content);
      break;

    case EVENT_TYPES.UPDATE_MESSAGE_STATUSES_READ: {
      eventHandlers.updateMessageStatuses(storeAPI, msg.content);
      break;
    }

    case EVENT_TYPES.TYPING_NOTIFICATION: {
      eventHandlers.showTypingNotification(storeAPI, msg.content);
      break;
    }

    case EVENT_TYPES.USER_ENTER: {
      eventHandlers.setOperatorName(storeAPI, msg.content);
      break;
    }

    default:
  }
};
